export default __webpack_public_path__ + "static/media/16.0831adb4.jpg";